import * as WebFont from 'webfontloader';

// // This doesnt need to be in a function, but it works with our structure
// var ConfiguredFonts = () => {
//     WebFont.load({
//         google: {
//             families: ['Russo One', 'Roboto Mono:500']
//         },
//         loading: () => {
//             console.warn("Hello! Loading the fonts now :)");
//         },
//         fontloading: (a, b) => {
//             console.warn("Loaded a font", a, b);
//         }
//     });
// };

// export default ConfiguredFonts;

WebFont.load({
    google: {
        families: ['Russo One', 'Roboto Mono:500', 'Merriweather']
    },
    loading: () => {
        // console.warn("Hello! Loading the fonts now :)");
    },
    fontloading: (a, b) => {
        // console.warn("Loaded a font", a, b);
    }
});



// WEBPACK FOOTER //
// ./src/core/ConfigureFonts.ts